<template>
  <div class="w-full space-y-5">
    <div class="bg-white rounded-14 flex items-center p-3">
      <img
        :src="images.programme"
        alt="sollicitation"
        class="w-68 h-68 m-5"
      >
      <div class="text-left uppercase">
        <div class="text-c18 font-c7 text-gray2">
          Nombre de PROGRAMMES
        </div>
        <div class="font-c7 text-c32 inputo">
          {{ stats.programs || 0 }}
        </div>
      </div>
    </div>
    <!--  -->
    <div class="bg-white rounded-14 p-5">
      <div class="flex items-center">
        <img
          :src="images.normalisation"
          alt="normalisation"
          class="w-68 h-68 m-5"
        >
        <div class="text-left uppercase">
          <div class="text-c18 font-c7 text-gray2">
            normalisation
          </div>
          <div class="font-c7 text-c32 inputo">
            {{ accountData.awaitNormalize + accountData.endNormalize +accountData.rejectedNormalize || 0 }}
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between px-5 gap-5">
        <div class="yellow w-1/2 rounded-8 text-left p-3">
          <div class="text-c18 font-c6">
            EN ATTENTE
          </div>
          <div class="text-c24 font-c8">
            {{ accountData.awaitNormalize || 0 }}
          </div>
        </div>
        <!--  -->
        <div class="bg-bgGreen w-1/2 rounded-8 text-left p-3">
          <div class="text-c18 font-c6 uppercase">
            Approuvé
          </div>
          <div class="text-c24 font-c8">
            {{ accountData.endNormalize || 0 }}
          </div>
        </div>
        <!--  -->
        <div class="bg-red w-1/2 rounded-8 text-left p-3">
          <div class="text-c18 font-c6 uppercase">
            Rejeté
          </div>
          <div class="text-c24 font-c8">
            {{ accountData.rejectedNormalize || 0 }}
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- <div class="bg-white rounded-14 flex items-center p-7">
      <img
        :src="images.partenaire"
        alt="partenaire"
        class="w-68 h-68 m-3"
      >
      <div class="text-left uppercase">
        <div class="text-c18 font-c7 text-gray2">
          Nombre de rejets de DGI
        </div>
        <div class="font-c7 text-c32 inputo">
          {{ accountData.rejectedNormalize || 0 }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import apiroutes from "../../../router/api-routes";
import http from "../../../plugins/https";
import icProgrammeNumber from "../../../assets/icons/ic-programmeNumber.svg";
import icNormalisation from "../../../assets/icons/ic-normalisation.svg";
import icPartenaireNumber from "../../../assets/icons/ic-partenaireNumber.svg";
import programme from "../../../assets/images/png/programme.png";
import normalisation from "../../../assets/images/png/normalisation.png";
import partenaire from "../../../assets/images/png/partenaire.png";

import { getAdminGlobalData, allDemande} from "@/component/cdevs/allFunctions";

export default {
  name: "Index",
  components: {},
  props: {
    accountData: {
      type: Object,
      default: () => ({}),
    },
    stats: {
      type: Object,
      default: () => ({}),
    },
    search: {
      type: String,
      default: null
    },
    filtrage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      icons: {
        icProgrammeNumber,
        icNormalisation,
        icPartenaireNumber,
      },
      images: {
        programme,
        normalisation,
        partenaire,
      },
      charge: false,
    };
  },
  created() {

  },
  methods: {
    // allDemandeParginate () {
    //   this.temoin = this.filtrage
    //   this.charge = true
    //   const body = {
    //     limit: this.limite,
    //     page: this.page,
    //     dgiStatus: this.filtrage === 'EN COURS' ? 'PENDING' : this.filtrage === 'APPROUVÉE' ? 'APPROVED' : 'REJECTED'
    //   }

    //   http.post(apiroutes.baseURL + apiroutes.allDemande, body)
    //       .then(response => {
    //         this.dataClient = response.rows
    //         this.total = response.count
    //         this.totalPage = parseInt(response.count / this.limite)
    //         if (this.totalPage === 0) {
    //           this.totalPage = 1
    //         }
    //         this.charge = false
    //         console.log(response)
    //       })
    //       .catch(error => {
    //         this.charge = false
    //     // console.log(error)
    //   })
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/sass/variables.scss";
.inputo {
  font-family: $font-default2;
}
.yellow{
  background: rgba(255, 255, 0, 0.684);
} 
</style>
